export function normalizeRuntimeHost(host: string | null | undefined): string {
	return String(host || '').trim().toLowerCase();
}

export function isImpersonationRuntimeEnabled(
	productionBuild: boolean,
	host: string | null | undefined
): boolean {
	if (!productionBuild) {
		return true;
	}
	const normalized = normalizeRuntimeHost(host);
	return normalized === 'staging' || normalized === 'local';
}

export function isOriginalSuperAdminRole(role: string | null | undefined): boolean {
	return role === 'sadmin' || role === 'superadmin';
}
